import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import './styles.scss'
import Icon from '../../../Shared/Icon'
import { sortableHandle } from 'react-sortable-hoc'
import Select from '../../../Shared/Form/Select'
import { constants, trackingEvent } from '../../../../constants'
import { patchImage, updateHeroImageForGiataId } from '../../../../api'
import Loader from '../../../Shared/Loader'
import PropTypes from 'prop-types'
import { imageRejectReasons } from './constants'
import LayerEditImage from './Layer/layerEditImage'
import LayerRejectImage from './Layer/layerRejectImage'
import { hasImageRoomsAssigned, isImageConfirmed, isRoomImage } from './utils'
import activityTrackingService from '../../../../services/activityTrackingService'

const IMAGE_TYPES = constants.imageTypes
const IMAGE_TYPES_MAP = new Map(IMAGE_TYPES.map((obj) => [obj.value, obj]))
const DragHandle = sortableHandle(() => <Icon size="medium" type="move" background={'transparent'}
                                              tooltip={'Drag me to reorder image'}/>)

class ImageBrowserItem extends Component {

  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      showLayerEditImage: false,
      showLayerRejectImage: false,
    }
  }

  onImageCategoryChange = (e) => {
    const code = e.target.value
    const label = IMAGE_TYPES_MAP.has(code) ? IMAGE_TYPES_MAP.get(code).label : ''
    activityTrackingService.trackEvent(trackingEvent.selectMotifType, { name: label })
    const body = { motifType: { code: e.target.value } }
    const { fetchPromise } = patchImage(this.props.image.giataId, this.props.image.id, body)
    this.setState({ loading: true }, () => {
      fetchPromise.then(() => {
        const newImage = { ...this.props.image }
        if (newImage.motifType !== Object(newImage.motifType)) {
          newImage.motifType = {}

        }
        newImage.motifType.code = body.motifType.code
        this.props.onImageChanged(newImage)
        this.setState({ loading: false })
      }).catch(() => {
        this.setState({ loading: false })
      })
    })
  }

  onHeroImageToggle = () => {
    let heroImageId = null
    if (!this.isHero()) {
      heroImageId = this.props.image.id
      activityTrackingService.trackEvent(trackingEvent.markAsHeroImage)
    }
    const { fetchPromise } = updateHeroImageForGiataId(this.props.image.giataId, heroImageId)
    this.setState({ loading: true }, () => {
      fetchPromise.then(() => {
        this.props.onHeroClick(this.props.image.id, !this.isHero())
        this.setState({ loading: false })
      }).catch(() => {
        this.setState({ loading: false })
      })
    })
  }

  onImageSelectToggle = () => {
    this.props.onImageSelectChange(
      this.props.image.id, !this.props.isSelected
    )
  }

  isSmallImage () {
    return !!(this.props.image.width && this.props.image.height && (this.props.image.width < 1920 || this.props.image.height < 1080))
  }

  isCMYK () {
    return (!!this.props.image.metadata) && (!!this.props.image.metadata.space) && (this.props.image.metadata.space.toLowerCase().trim() === 'cmyk')
  }

  isHero () {
    return !!this.props.image.hero
  }

  onRejected = (info) => {
    const image = { ...this.props.image }
    image.infoRejected = info
    this.props.onImageChanged(image)
  }

  showLayerEditImage () {
    this.setState({ showLayerEditImage: true })
  }

  onImageContainerClick = () => {
    activityTrackingService.trackEvent(trackingEvent.openEditImageBar,
      { source: 'Click image' }
    )
    this.showLayerEditImage()
  }

  onEditIconClick = () => {
    activityTrackingService.trackEvent(trackingEvent.openEditImageBar,
      { source: 'Pen Icon' }
    )
    this.showLayerEditImage()
  }

  onAssignImageToARoomClick = () => {
    activityTrackingService.trackEvent(trackingEvent.openEditImageBar,
      { source: 'Room assign icon' }
    )
    this.showLayerEditImage()
  }

  isRejected () {
    return this.props.image.infoRejected !== null
  }

  getRejectMessage () {
    if (!this.isRejected()) {
      return 'Reject'
    }
    if (this.props.image.infoRejected.hasOwnProperty('reason')) {
      return 'Reject reason: ' + this.props.image.infoRejected.reason
    }
    return 'Reject reason: ' + imageRejectReasons[this.props.image.infoRejected.type]
  }

  getThumbUrl () {
    return this.props.image.thumbnailUrl
  }

  hasSelectionStarted () {
    return this.props.selectedImagesCount > 0
  }

  render () {
    const { t } = this.props
    const classNames = ['Imagebrowseritem']
    this.props.isSelected && classNames.push('Imagebrowseritem-selected')
    const selectionStarted = this.hasSelectionStarted()
    selectionStarted && classNames.push('Imagebrowseritem-selection')
    return (
      <div className={classNames.join(' ')} key={this.props.image.id}>
        {this.state.loading && <Loader size={32}/>}
        <React.Fragment>
          <LayerEditImage image={this.props.image} number={this.props.number} show={this.state.showLayerEditImage}
                          onHideClick={() => this.setState({ showLayerEditImage: false })}
                          onImageChanged={this.props.onImageChanged} onZoomClick={this.props.onZoomClick}
                          permissions={this.props.permissions}
                          rooms={this.props.rooms} roomAttributes={this.props.roomAttributes}
          />
          {isImageConfirmed(this.props.image) &&
            <LayerRejectImage image={this.props.image} number={this.props.number} onRejected={this.onRejected}
                              show={this.state.showLayerRejectImage}
                              onHideClick={() => this.setState({ showLayerRejectImage: false })}/>
          }
        </React.Fragment>
        <div className="Imagebrowseritem-Image-Container"
             onClick={!selectionStarted ? this.onImageContainerClick : this.onImageSelectToggle}>
          <div className={'Imagebrowseritem-Image'}
               style={{ backgroundImage: 'url(' + this.getThumbUrl() + ')' }}/>
        </div>
        <div className="Imagebrowseritem-Toolbar-Top">
          {!selectionStarted &&
            <React.Fragment>
              <DragHandle/>
              <Icon onClick={this.onEditIconClick} size="medium"
                    type="edit" background="transparent"/>
              <Icon size="medium" type="im" imClassName="im-magnifier" background="transparent"
                    onClick={() => this.props.onZoomClick(this.props.number)}/>
            </React.Fragment>
          }
          <Icon size="medium" type="fa"
                extraClassNames={this.props.isSelected ? 'icon-image-selection icon-image-selected' : 'icon-image-selection'}
                faClassName={
                  this.props.isSelected ? 'fa-check-square' : 'fa-square-o'
                } background="transparent"
                onClick={this.onImageSelectToggle}/>
        </div>
        {this.props.isSelected && <div className={'overlay-container'} onClick={this.onImageSelectToggle}>
          <div className={'overlay'}></div>
        </div>}
        <div className="Imagebrowseritem-Toolbar">
          {IMAGE_TYPES !== undefined &&
            <div className={'Imagebrowseritem-Toolbar-MotifType'}>
              <Select type="small" options={IMAGE_TYPES}
                      style={{ overflow: 'hidden' }}
                      selected={this.props.image.motifType ? this.props.image.motifType.code : ''}
                      onChange={this.onImageCategoryChange}/>
            </div>
          }
          <React.Fragment>
            <div className="Imagebrowseritem-Toolbar-Icons">
              {this.isHero() ? (
                <Icon size="small" type="favorite"
                      onClick={() => this.onHeroImageToggle()}
                      tooltip={t('MAIN_IMAGE_TOGGLE_OFF')}/>
              ) : (
                <Icon size="small" type="favorite" background={'grey'}
                      onClick={() => this.onHeroImageToggle()}
                      tooltip={t('MAIN_IMAGE_TOGGLE_ON')}/>
              )}
              {
                isRoomImage(this.props.image) && !hasImageRoomsAssigned(this.props.image) &&
                <Icon size="small" type="warning" tooltip={t('PLEASE_ASSIGN_IMAGE_TO_A_ROOM')}
                      onClick={this.onAssignImageToARoomClick}/>
              }
              {
                isImageConfirmed(this.props.image)
                && this.isRejected()
                &&
                (
                  this.props.isGiataUser ?
                    <Icon
                      size="small"
                      type="rejected"
                      tooltip={this.getRejectMessage()}
                      onClick={() => this.setState({ showLayerRejectImage: true })}
                    />
                    :
                    <Icon
                      size="small"
                      type="rejected"
                      tooltip={this.getRejectMessage()}
                    />
                )
              }
              {this.isSmallImage() && (
                this.isCMYK() ?
                  <Icon size="small" type="flash"
                        tooltip={t('IMAGE_IS_CMYK')}/>
                  :
                  <Icon size="small" type="flash"
                        tooltip={t('IMAGE_IS_SMALL_IMAGE')}/>
              )
              }
              {isImageConfirmed(this.props.image) && (
                <Icon size="small" type="published" tooltip={t('IMAGE_CONFIRMED')}/>
              )}
            </div>
          </React.Fragment>
        </div>
      </div>
    )
  }
}

ImageBrowserItem.propTypes = {
  image: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
  roomAttributes: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  onZoomClick: PropTypes.func.isRequired,
  onHeroClick: PropTypes.func.isRequired,
  onImageChanged: PropTypes.func.isRequired,
  isGiataUser: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onImageSelectChange: PropTypes.func.isRequired,
  selectedImagesCount: PropTypes.number.isRequired
}

export default withTranslation()(ImageBrowserItem)
